/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';

export default { 

  listByLoad(config: {params: { loadId: number }}) {
    return Api(true).get('/load_event/list_by_load', config);
  },

  createComment(params: { 
    loadId: number,
    comment: string,
    isCritical: boolean,
  }) {
    return Api(true).post('/load_event/create_comment', params);
  },

  markAsCritical(params: { 
    loadEventId: number,
    isCritical: boolean,
  }) {
    return Api(true).post('/load_event/is_critical', params);
  },

};
